import {IJobTitleInfo} from "./job-title.interface";
import {consts} from "../common/modals/consts";
import {IJobLevelInfo} from "./job-level.interface";
import {ElectricalWorkType} from './electrical-work-type';

export class JobTitleInfo implements IJobTitleInfo{
  defaultJobLevelId: string;
  description: string;
  id: string;
  isSelected: boolean;
  name: string;
  defaultJobLevelName?: string;
  electricalWorkType?: ElectricalWorkType;
  operativeTypeId: string;

  get jobLevelIsSet(): boolean {
    return this.defaultJobLevelId != consts.emptyGuid;
  }

  get isValid(): boolean {
    return !!this.name && !!this.description && this.defaultJobLevelId != consts.emptyGuid && !!this.electricalWorkType.toString();
  }

  getDefaultJobLevel(allJobLevels: IJobLevelInfo[]) : IJobLevelInfo {
    let jobLevel = allJobLevels.find(l => l.id === this.defaultJobLevelId);
    this.defaultJobLevelName = jobLevel?.name;
    return jobLevel;
  }

  constructor(iJobTitleInfo: IJobTitleInfo = null) {
    this.id = iJobTitleInfo?.id ?? consts.emptyGuid;
    this.name = iJobTitleInfo?.name ?? "";
    this.description = iJobTitleInfo?.description ?? "";
    this.isSelected = iJobTitleInfo?.isSelected ?? false;
    this.defaultJobLevelId = iJobTitleInfo?.defaultJobLevelId ?? consts.emptyGuid;
    this.defaultJobLevelName = iJobTitleInfo?.defaultJobLevelName ?? '';
    this.electricalWorkType = iJobTitleInfo?.electricalWorkType;
    this.operativeTypeId = iJobTitleInfo?.operativeTypeId ?? consts.emptyGuid;
  }

}
